import React from "react";

// Library imports
import { ResponsiveContainer, AreaChart, Area, YAxis } from "recharts";

// Misc Imports
import { makeStyles } from "@styles";

const useStyles = makeStyles(() => ({
  chart: {
    overflow: "visible",
  },
}));

type Props = {
  dataPoints: number[];
};

export function LineGraph(props: Props): JSX.Element | null {
  const classes: any = useStyles({});

  const { dataPoints } = props;
  if (!dataPoints?.length) return null;

  const data: Array<{ value: number; argument: number }> = dataPoints.map(
    (value, index) => ({
      value,
      argument: index,
    }),
  );
  const minValue: number = Math.min.apply(null, dataPoints);
  const maxValue: number = Math.max.apply(null, dataPoints);
  const padding = Math.max((maxValue - minValue) * 0.12, maxValue * 0.015);

  return (
    <ResponsiveContainer width="100%" height={126} className={classes.chart}>
      <AreaChart
        data={data}
        margin={{ top: 10, right: 8, left: 8, bottom: 6 }}
        padding={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="btcPriceGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FF3333" stopOpacity={0.28} />
            <stop offset="75%" stopColor="#FF3333" stopOpacity={0.04} />
            <stop offset="100%" stopColor="#FF3333" stopOpacity={0} />
          </linearGradient>
        </defs>
        <YAxis hide domain={[minValue - padding, maxValue + padding]} />
        <Area
          isAnimationActive={false}
          type="monotone"
          dataKey="value"
          stroke="#FF3333"
          strokeWidth={3}
          fillOpacity={1}
          fill="url(#btcPriceGradient)"
          dot={false}
          activeDot={{ r: 4, strokeWidth: 0, fill: "#FF3333" }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
